












































































import { Component, Prop, Vue } from "vue-property-decorator";
import PaymentInfoModal from "../components/PaymentInfoModal.vue";
import { isNewProject } from "@/preferences";

import PurchaseStatus from "@/usecases/orders/purchase-status";
import PurchaseStatusTranslater from "@/usecases/orders/purchase-status-translater";
import purchaseStatus from "@/usecases/accounting/purchase-status";
import purchaseStatusTranslater from "@/usecases/accounting/purchase-status-translater";

import TextTemplateModal from "@/views/TextTemplateModal.vue";
import { PurchasePayment } from "@/usecases/accounting/purchase";

@Component({
  components: {
    PaymentInfoModal,
    TextTemplateModal
  }
})
export default class PaymentPurchasePage extends Vue {
  @Prop({ required: true }) purchase!: PurchasePayment;
  @Prop({ required: true }) bankAccounts!: any;

  textTemplateModalOpen: boolean = false;
  oldStatus: string = "";

  get purchaseItems() {
    return [
      { label: "発注書No", value: this.purchase.purchaseNumber },
      { label: "件名", value: this.purchase.title },
      { label: "請求担当者", value: this.purchase.staffName },
      { label: "発行日", value: this.purchase.dateOfIssue },
      { label: "支払予定日", value: this.purchase.issuedAt },
      { label: "発注先", value: this.purchase.vendorName },
      {
        label: "発注額",
        value:
          (this.purchase.lossTotal
            ? this.purchase.lossTotal.toLocaleString()
            : 0) + "円"
      }
    ];
  }

  get statusOptions() {
    if (isNewProject(this.purchase.projectCreated)) {
      return PurchaseStatus.all().map(value => ({
        value,
        text: PurchaseStatusTranslater.toJp(value)
      }));
    }

    return purchaseStatus.all().map(value => ({
      value,
      text: purchaseStatusTranslater.toJp(value)
    }));
  }

  addTextToMention(text: string) {
    if (this.purchase.note) {
      this.purchase.note += "\n";
    }
    this.purchase.note += text;
    this.textTemplateModalOpen = false;
  }

  get amountDifference() {
    return (
      this.purchase.lossTotal - this.purchase.amountReceived
    ).toLocaleString();
  }

  show() {
    this.oldStatus = this.purchase.status;
    (this.$refs.modal as any).show();
  }

  hide() {
    (this.$refs.modal as any).hide();
  }

  async submitForm() {
    (this.$refs.btnSubmit as any).click();
  }

  handleSave() {
    this.$emit("savePurchase", this.purchase);
  }

  get disabledStatus(): boolean {
    return this.oldStatus === PurchaseStatus.Invalid;
  }
}
